import React, { useState } from 'react';
import { connect } from 'react-redux';
/* import { withFirebase } from 'react-redux-firebase';
 */import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import MainTitle from '../../components/MainTitle';
import ButtonBase from '../../components/Buttons/ButtonBase';
import ConfirmationDialog from '../../components/ConfirmationDialog';
import UpdatePassword from './components/UpdatePassword';
import UpdatePhoneNumber from './components/UpdatePhoneNumber';

const useStyles = makeStyles({
  card: {
    marginTop: 24,
    maxWidth: 840
  },
  lastCard: {
    margin: '24px 0 104px 0',
    maxWidth: 840
  },
  cardHeader: {
    display: 'block',
    paddingBottom: 0,
    '&:after': {
      content: '""',
      display: 'block',
      margin: '0 auto',
      width: '100%',
      paddingTop: '8px',
      borderBottom: '1px solid #c1c1c1',
    },
  },
  cardTitle: {
    fontSize: '22px',
    fontWeight: 'bold',
    color: '#10587f',
  },
  phoneDeleteAccount: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#013957',
  },
  titleDeleteAccount: {
    color: '#10587f',
    textAlign: 'center',
    fontSize: 22,
    fontWeight: 'bold',
  },
  contentTextDeleteAccount: {
    color: '#484848',
    fontSize: 16,
  },
  contractButton: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    '@media (max-width: 767px)': {
      width: '100%',
    },
  },
});

const Account = props => {
  const { profile } = props;
  /* const { auth } = props.firebase; */
  const classes = useStyles();
  const [openDeleteAccount, toggleDeleteAccount] = useState(false);
  const [openDeletePremiumUser, toggleDeletePremiumUser] = useState(false);
  const tabletSize = useMediaQuery('(max-width:768px)');

  const handleDeleteUser = () => {
   /*  const { auth } = props.firebase;
    const user = auth().currentUser; */

   /*  user
      .delete()
      .then(function() {
        props.history.push('/dashboard');
      })
      .catch(function(error) {
        
      }); */
  };

  const isPremiumUser = false;

  return (
    <div style={{ width: '100%', maxWidth: 840, margin: 'auto' }}>
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            padding: tabletSize ? '0 24px' : '0',
          }}
        >
          <MainTitle title="Cuenta" subtitle="Edita tu información." />
          {profile && profile.membership && profile.membership.type !== 'Free' ?
            <div className={classes.contractButton}>
              <a  href={'/files/Contrato-Adhesion.pdf'} target="_blank" rel="noopener noreferrer">
                <ButtonBase variant="primary" style={{ width: 200, marginTop: 30 }}>
                  Visualizar contrato
                </ButtonBase>
              </a>
            </div> : null
          }
        </div>

        <Card className={classes.card}>
          <CardHeader
            title={<Typography className={classes.cardTitle}>Email</Typography>}
            className={classes.cardHeader}
          />
          <CardContent>
            <Typography>
              Tu dirección de correo no se puede cambiar, únicamente es
              informativa.
            </Typography>
            <br />
            {profile && profile.email && (
              <TextField
                id="email"
                type="email"
                label="Correo electrónico"
                variant="outlined"
                defaultValue={profile.email}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
              />
            )}
          </CardContent>
        </Card>

        <Card className={classes.card}>
          <CardHeader
            className={classes.cardHeader}
            title={
              <Typography className={classes.cardTitle}>
                Cambiar Contraseña
              </Typography>
            }
          />
          <CardContent>
            <UpdatePassword />
          </CardContent>
        </Card>

        <Card className={classes.lastCard}>
          <CardHeader
            title={
              <Typography className={classes.cardTitle}>
                Número Telefónico
              </Typography>
            }
            className={classes.cardHeader}
          />
          <CardContent>
            <UpdatePhoneNumber />
          </CardContent>
        </Card>

        {/* <br />
        <div style={{ textAlign: 'right', fontSize: 14, marginRight: 10 }}>
          <Link
            component="button"
            onClick={() => {
              isPremiumUser
                ? toggleDeletePremiumUser(true)
                : toggleDeleteAccount(true);
            }}
          >
            Eliminar Cuenta
          </Link>
        </div>
        <br />

        <ConfirmationDialog
          open={openDeleteAccount}
          title={'¿Quieres eliminar tú cuenta?'}
          subtitle={
            'Si eliminas la cuenta se perdera toda la información recopilada hasta el momento.'
          }
          handleClose={() => toggleDeleteAccount(false)}
          handleAccept={handleDeleteUser}
        />

        <Dialog
          open={openDeletePremiumUser}
          onClose={() => toggleDeletePremiumUser(false)}
          maxWidth="xs"
        >
          <DialogTitle>
            <Typography className={classes.titleDeleteAccount}>
              ¿Quieres eliminar tú cuenta?
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText className={classes.contentTextDeleteAccount}>
              Para continuar con tú proceso, para eliminar tú cuenta, comunicate
              al siguiente teléfono:
            </DialogContentText>
            <Typography className={classes.phoneDeleteAccount} align="center">
              55-11-22-33-44
            </Typography>
          </DialogContent>
          <DialogActions>
            <ButtonBase
              variant="primaryOutlined"
              onClick={() => toggleDeletePremiumUser(false)}
            >
              Entendido
            </ButtonBase>
          </DialogActions>
        </Dialog> */}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  profile: state.authClient,
});

export default connect(mapStateToProps)(Account);
